import { MYHOUSE_AUTHENTICATION_CATEGORY_TYPE } from '@Root/contants/myhouseRegister'
import { MyhouseStateGuide } from '@Root/slices/myhouse/mainSlice'
import { NCLICK } from '@Root/contants/lcs'

export const OWNER_AUTH_WAIT = {
  state: 'INIT',
  title: '우리집 인증',
  contents: '인증하면 호별 시세 확인 및 입주민 리뷰를 작성할 수 있습니다.',
  grayTrailContents: '(단, 단지 별로 제공하는 서비스에 차이가 있습니다.)',
  routeTitle: '우리집 인증하기',
  routeNclick: NCLICK.MY_HOUSE.MAIN_INFO.AUTHENTICATION_GUIDE.OWNER,
} as MyhouseStateGuide

export const OWNER_AUTH_PROGRESS = {
  state: 'ING',
  title: '집주인 인증을 진행 중입니다.',
  contents: '인증 완료까지 영업일 기준 1~3일의 기간이 소요됩니다.',
} as MyhouseStateGuide

export const OWNER_AUTH_FAIL = {
  state: 'FAIL',
  title: '집주인 인증에 실패하였습니다.',
  routeTitle: '다시 인증하기',
  routeNclick: NCLICK.MY_HOUSE.MAIN_INFO.AUTHENTICATION_GUIDE.OWNER_FAIL_RETRY,
} as MyhouseStateGuide

export const RESIDENT_AUTH_WAIT = {
  state: 'INIT',
  title: '입주민 인증',
  contents: '인증하면 호별 시세 확인 및 입주민 리뷰를 작성할 수 있습니다.',
  grayTrailContents: '(단, 단지 별로 제공하는 서비스에 차이가 있습니다.)',
  routeTitle: '입주민 인증하기',
  routeNclick: NCLICK.MY_HOUSE.MAIN_INFO.AUTHENTICATION_GUIDE.RESIDENT,
} as MyhouseStateGuide

export const RESIDENT_AUTH_PROGRESS = {
  state: 'ING',
  title: '입주민 인증을 진행 중입니다.',
  contents: '인증 완료까지 영업일 기준 1~3일의 기간이 소요됩니다.',
} as MyhouseStateGuide

export const RESIDENT_AUTH_FAIL = {
  state: 'FAIL',
  title: '입주민 인증에 실패하였습니다.',
  routeTitle: '다시 인증하기',
  routeNclick: NCLICK.MY_HOUSE.MAIN_INFO.AUTHENTICATION_GUIDE.RESIDENT_FAIL_RETRY,
} as MyhouseStateGuide

export const TRADE_EXPIRED = {
  state: 'TRADE_EXPIRED',
  title: '우리집을 삭제 또는 수정해 주세요.',
  contents: '전월세 만기일이 지났습니다. 이사 가셨다면 이전 주소지를 삭제해 주시고, 계약을 연장하셨다면 만기일자를 수정해 주세요.',
  deleteTitle: '이 주소의 우리집 삭제하기',
  modifyTitle: '만기일자 수정하기',
} as MyhouseStateGuide

export enum MYHOUSE_AUTH_RESULT_COMMENT {
  ADDRESS_INCORRECT = '주소지 불일치',
  NAME_INCORRECT = '성명 불일치',
  FILE_IDENTIFICATION_FAIL = '파일 식별 불가',
  UNNECESSARY_PERSONAL_INFORMATION = '불필요한 개인정보 포함',
  ADDRESS_AND_NAME_INCORRECT = '주소지 불일치,성명 불일치',
}

export enum MYHOUSE_AUTH_FAIL_GUIDE_COMMENT {
  ADDRESS_INCORRECT_COMMENT = '주소지 정보가 일치하지 않습니다.',
  NAME_INCORRECT_COMMENT = '실명 정보가 일치하지 않습니다.',
  ADDRESS_NAME_INCORRECT_COMMENT = '실명 및 주소지 정보가 일치하지 않습니다.',
  FILE_IDENTIFICATION_FAIL_COMMENT = '흔들림, 빛 번짐 등의 사유로 주소지 확인이 불가합니다.',
  UNNECESSARY_PERSONAL_INFORMATION_COMMENT = '주소지 외 불필요한 개인정보가 포함되었습니다.',
}

export enum MYHOUSE_AUTH_METHOD {
  OWNER_REJECT = 'OWNER_REJECT',
  OWNER_FAIL = 'OWNER_FAIL',
  RESIDENT_REJECT = 'RESIDENT_REJECT',
  RESIDENT_FAIL = 'RESIDENT_FAIL',
}
